import React from "react";
import { useTranslation } from "react-i18next";
import { programWeek } from "@features/programs/utils/gamification";
import "./gamification.css";

/**
 * One line for the program card: "Diese Woche 2 von 3" and a dot per
 * prescribed session. Nothing else — the card is already dense.
 */
export function WeekRow({ program, now = null }) {
  const { t } = useTranslation();
  const week = programWeek(program, now || new Date());

  if (!week.goal) return null;

  return (
    <div className="gm gm-week-row">
      <span>{t("gamification.week.title")}</span>
      <b>{t("gamification.week.of", { done: week.done, goal: week.goal })}</b>
      <span className="gm-week-row-dots" aria-hidden="true">
        {Array.from({ length: week.goal }, (_, index) => (
          <i key={index} className={index < week.done ? "on" : undefined} />
        ))}
      </span>
    </div>
  );
}

export default WeekRow;
